/* SORT TYPES */
export const NAME = 'name';
export const LAST_SEEN = 'lastSeen';
export const CREATED = 'created';
export const EXPIRED = 'expired';
export const STATUS = 'status';
export const REPORT = 'report';

/* FEATURE TOGGLE TYPES */
export const EXPERIMENT = 'experiment';
export const RELEASE = 'release';
export const OPERATIONAL = 'operational';
export const KILLSWITCH = 'kill-switch';
export const PERMISSION = 'permission';

/* DAYS */
export const FOURTYDAYS = 40;
export const SEVENDAYS = 7;
